
function Disclamer(){
    
    let fileReader  = new FileReader();
    let data =[]
    let file =new File(data, '/disclamer.txt')
    console.log(file)
    fileReader.onload = () => {
        console.log( fileReader.result);
    };
    fileReader.readAsText(file);
      
    fetch('anything.txt')
    .then(response => response.text()) 
    .then(textString => {
        console.log(textString);
    });
    return(
        <div>
<header>Disclamer</header>

<p>The following terms of use are intended to inform users of the limitations and usage guidelines of the artificial intelligence chatbot “Mindsherpa” provided by the company “Mindsherpa”.</p>
<p>The user is defined as the person interacting with the AI Chatbot.  </p>
<hr></hr>
<h1>Limitations</h1>
<p>The chatbot is limited by its technical capabilities, any information provided by it may be inaccurate or incomplete. Any information obtained directly from the chatbot should be confirmed against a secondary source. Mindsherpa assumes no responsibility or guarantee for the accuracy or completeness of the information provided.</p>
<p>Additionally, the Mindsherpa chatbot is not a replacement for a trained professional and should not be treated as one.</p>
<p>Neither Mindsherpa nor any of our other Services provide any emergency or urgent medical services. PLEASE CALL 911 OR YOUR HEALTH CARE PROVIDER IF YOU BELIEVE THAT YOU ARE EXPERIENCING A MEDICAL EMERGENCY OR IF YOU NEED URGENT CARE.</p>
<hr></hr>
<h1>Privacy</h1>
<p>Mindsherpa stores data on the user’s activity for functionality and continued service development. Any data used for development purposes is anonymized prior to storage. Data that is stored for functionality may be personally identifiable information (PII) or sensitive information, it is stored securely and may be deleted at the user’s request.</p>
<p>Data that is viewed as part of the service provided to the primary account contains some personal data but is presented in an aggregate form to prevent identification.</p>
<hr></hr>
<h1>Self Evaluations</h1>
<p>The self evaluations provided as part of the app are for personal use only, the results are not shared with account administrators. The results of self evaluations should not be interpreted as a diagnosis.</p>
<hr></hr>
<h1>Online Sessions</h1>
<p>·         No inappropriate content</p>
<p>·         Presenter is not part of Mindsherpa</p>
<p>·         …</p>
<hr></hr>
<h1>Important Disclaimer</h1>
<p>This AI chatbot is designed to provide helpful information and engage in conversation. However, it is an artificial intelligence and its understanding and responses are based on the data it has been trained on, which may have limitations and biases. Your use of this chatbot is anonymous, and the content of your conversations will not be shared with your employer. The information provided by this chatbot should not be considered professional advice. For specific advice tailored to your situation, please consult with qualified professionals in the relevant field (e.g., doctors, lawyers, financial advisors, therapists). We are not responsible for any actions taken based on the information provided by this chatbot.</p>

<hr></hr>
<h1>Guided Meditation</h1>  


        </div>
    )
}

export {Disclamer};

/*

*/